export default __webpack_public_path__ + "static/media/gallery-wip-emitter-body_02.911ed42e.jpg";